import { Component, ViewChild, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "ng2-translate";
import { dashboardResultService } from "../dashboardResultService";
import { dialogComponent } from "../dialog/dialog.component";
import { CommonService } from "../shared/services/common.service";
import { HttpService } from "../shared/services/http.service";
import { SessionHandler } from "../shared/services/session-handler.service";
import { Location } from "@angular/common";
import {
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl,
} from "@angular/platform-browser";
import { MaterialModule, MdDialog, MdDialogRef } from "@angular/material";
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: "progress-status",
  template: require('./progress-status.component.html'),
  styles: [require('./progress-status.component.scss')],
})
export class ProgressStatusComponent implements OnInit, OnDestroy {
  editing = {};
  rows = [];
  columns = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  soId: any;
  userData: any;
  isAdmin = false;
  userRole: any;
  tradePartnerId;
  dialogRef: any;
  statusData;
  postData1;
  date;

  isDoc: any;
  showDocument: any = [];
  uploadedDocList: any = [];
  showingMediaErrorMsg: any;
  showingmediaError: boolean;
  testSo;
  temp: any = [];
  result: any = [];
  pdfDownload: any = [];
  img: any = [];
  showDocuments: any = [];
  showImage;
  reportURL;
  history: any = [];
  historyTR: any;
  pending: any;
  isdate: any;
  currentStatusDescription: any;

  // --- language support ---
  languages: string[] = ["English", "French", "Italian", "German"];
  selectedLanguage: string = "English";
  private langSub: Subscription;
  // -------------------------

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private http: HttpService,
    private serverResultsService: dashboardResultService,
    private sessionHandler: SessionHandler,
    public dialog: MdDialog,
    private commonService: CommonService,
    private translate: TranslateService,
    private location: Location
  ) {
    if (this.http.checkSession()) {
      this.soId = this.activatedRoute.snapshot.paramMap.get("id");
      console.log(this.soId);
      this.userData = JSON.parse(this.sessionHandler.getItem("loginData"));
      if (
        this.userData &&
        Object.keys(this.userData).length > 0 &&
        this.userData.role &&
        this.userData.role.length > 0
      ) {
        if (this.userData.role.includes("ADMIN")) {
          this.isAdmin = true;
        }
        if (
          this.userData &&
          this.userData.role &&
          this.userData.role.length > 0
        ) {
          this.userRole = this.userData.role.join();
        }
        if (this.isAdmin) {
          this.tradePartnerId = "";
        }
        // ******new Condition for tradepartner with admin role********
        if (this.userData.role.includes("TRADE_PARTNER")) {
          this.tradePartnerId = this.userData.tradePartnerId;
        } else {
          this.tradePartnerId = this.userData.tradePartnerId;
        }
      }

      // --- initialize language from saved choice (if any) ---
      try {
        const saved = localStorage.getItem("appLanguage");
        if (saved && this.languages.indexOf(saved) !== -1) {
          this.selectedLanguage = saved;
          this.translate.use(saved); // expects loader mapping like /assets/i18n/English.json
        } else {
          this.selectedLanguage = "English";
          this.translate.setDefaultLang("English");
          this.translate.use("English");
        }
      } catch (e) {
        console.warn("Language init error", e);
      }

      // subscribe to global language changes
      this.langSub = this.commonService.langChange.subscribe((lang: any) => {
        if (lang && this.languages.indexOf(lang) !== -1) {
          this.selectedLanguage = lang;
          try {
            this.translate.use(lang);
            localStorage.setItem("appLanguage", lang);
          } catch (e) {
            console.error("translate.use failed", e);
          }
          // re-fetch status in the selected language (if we already have soId)
          this.getStatus();
        }
      });
      // ---------------------------------------------------------
    } else {
      this.http.showSessionError();
    }
  }

  ngOnInit() {
    this.getStatus();
  }

  ngOnDestroy() {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  public getStatus() {
    // guard
    if (!this.soId) {
      return;
    }

    // map the UI language names to the language codes the backend expects
    const langMap: { [k: string]: string } = {
      English: "EN",
      French: "FR",
      Italian: "IT",
      German: "DE",
    };

    // prefer the selectedLanguage (initialised from localStorage) but fall back to English
    const uiLang = this.selectedLanguage || localStorage.getItem("appLanguage") || "English";
    const userLang = langMap[uiLang] || "EN";

    const url = `serviceOrder/v1/getServiceOrderProgressStatus?serviceOrderId=${this.soId}&userLanguage=${userLang}`;

    this.http.getRequest(url).subscribe(
      (res) => {
        if (res && res["status"] !== "Error") {
          this.statusData = res["response"];
          this.historyTR = this.statusData.statusHistory || [];
          this.pending = this.statusData.pendingStatusDes;
          // reset history before filling
          this.history = [];
          for (let i = 0; i < this.historyTR.length - 1; i++) {
            this.history.push(this.historyTR[i]);
          }
          if (this.statusData.currentStatusDes == "") {
            this.currentStatusDescription = this.statusData.status;
          } else {
            this.currentStatusDescription = this.statusData.currentStatusDes;
          }
          this.isdate = this.statusData.simpleDate;
          this.date = this.isdate == null ? "Not Available" : this.statusData.simpleDate;

          this.postData1 = {
            transactionId: res["response"].socId,
          };
          this.getWorkReport(this.postData1); // Call ServiceDocdownload api for Work Report(soc id)

          const postData = { transactionId: this.soId };
          this.getIsaDoc(postData); // call servicedoc api to download img (so id)

          this.http.onEnd();
        } else {
          this.dialogRef = this.dialog.open(dialogComponent);
          this.dialogRef.componentInstance.msg =
            "Something went wrong. Kindly contact to support.";
          this.http.onEnd();
        }
      },
      (err) => {
        if (err && err.status != 0) {
          this.dialogRef = this.dialog.open(dialogComponent);
          this.dialogRef.componentInstance.msg = err;
        }
        this.http.onEnd();
      }
    );
  }

  // Credit notes code starts //
  creditNotes() {
    const data = { serviceOrderId: 425 };
    this.http
      .postRequest(data, "_ah/api/serviceOrder/v1/requestCreditNotes")
      .subscribe(
        (res) => {
          console.log(res);
        },
        (err) => {
          if (err && err.status != 0) {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = "Failed to print label";
          }
          this.http.onEnd();
        }
      );
  }
  // credit notes code ends //

  getIsaDoc(data) {
    console.log("inside sevicedoc api.............");
    this.http.downloadPostRequest("document/downloadDocument", data).subscribe(
      (res) => {
        this.sanitizeUrl(res["data"]);
        this.http.onEnd();
      },
      (err) => {
        this.showingMediaErrorMsg = "error in fetch image data";
        this.showingmediaError = true;
        this.http.onEnd();
      }
    );
  }

  sanitizeUrl(data) {
    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].documentSource == "ISA") {
          this.uploadedDocList.push(data[i]);
        }
      }
      console.log(this.uploadedDocList);
    }
  }

  navigateDocLink(docUrl) {
    this.dialogRef = null;
    this.dialogRef = this.dialog.open(ViewProgressDialog);
    this.dialogRef.componentInstance.urlList = docUrl;
    this.http.onEnd();
  }

  getWorkReport(data) {
    this.http.downloadPostRequest("document/downloadDocument", data).subscribe(
      (res) => {
        if (res["code"] != "200") {
          this.showingMediaErrorMsg = res["message"];
          this.showingmediaError = true;
          this.isDoc = true;
        } else {
          this.showingmediaError = false;
          this.showDocuments = res["data"];
          if (this.showDocuments && this.showDocuments.length > 0) {
            for (let i = 0; i < this.showDocuments.length; i++) {
              if (this.showDocuments[i].documentName.match(/.(pdf)$/i)) {
                this.pdfDownload.push(this.showDocuments[i]);
              } else {
                this.img.push(this.showDocuments[i]);
              }
            }
            this.pdfDownload.sort(
              (a, b) =>
                +new Date(a.documentUploadDate) - +new Date(b.documentUploadDate)
            );

            this.sanitizeUrl(this.img);

            // arrange documents in decreasing order(latest doc at top)
            this.pdfDownload = this.pdfDownload.reverse();

            this.result.push(this.pdfDownload[0]);

            //Remove duplicate pdf
            for (var i = 1; i < this.pdfDownload.length; i++) {
              if (
                this.pdfDownload[i].documentName ===
                this.pdfDownload[i - 1].documentName
              ) {
                continue;
              } else {
                this.result.push(this.pdfDownload[i]);
              }
            }

            var en_flag: boolean = false;
            var it_flag: boolean = false;
            var nl_flag: boolean = false;
            var fr_flag: boolean = false;
            var de_flag: boolean = false;
            for (var i = 0; i < this.result.length; i++) {
              if (
                this.result[i].documentName.search("EN.pdf") !== -1 &&
                en_flag == false
              ) {
                this.temp.push(this.result[i]);
                en_flag = true;
              } else if (
                this.result[i].documentName.search("IT.pdf") !== -1 &&
                it_flag == false
              ) {
                this.temp.push(this.result[i]);
                it_flag = true;
              } else if (
                this.result[i].documentName.search("NL.pdf") !== -1 &&
                nl_flag == false
              ) {
                this.temp.push(this.result[i]);
                nl_flag = true;
              } else if (
                this.result[i].documentName.search("FR.pdf") !== -1 &&
                fr_flag == false
              ) {
                this.temp.push(this.result[i]);
                fr_flag = true;
              } else if (
                this.result[i].documentName.search("DE.pdf") !== -1 &&
                de_flag == false
              ) {
                this.temp.push(this.result[i]);
                de_flag = true;
              } else {
                continue;
              }
            }
            console.log(this.temp);

            this.isDoc = false;
            var conformMsg = res["message"];
            setTimeout(() => {
              //this.lightboxInit();
            }, 100);
          } else {
            this.isDoc = true;
          }
        }
      },
      (err) => {
        this.showingMediaErrorMsg = "error in fetch image data";
        this.showingmediaError = true;
      }
    );
  }

  //Download Report
  downloadd(ind) {
    console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%" + ind);
    for (var i = 0; i < this.temp.length; i++) {
      if (this.temp[i].documentName == ind) {
        this.reportURL = this.temp[i].urlMediaLink;
        this.downloadReport();
      }
    }
  }

  //Download Report
  downloadReport() {
    window.open(this.reportURL);
  }

  downloadImage(url) {
    window.open(url);
  }

  updateValue(event, cell, rowIndex) {
    console.log("inline editing rowIndex", rowIndex);
    this.editing[rowIndex + "-" + cell] = false;
    this.rows[rowIndex][cell] = event.target.value;
    console.log("UPDATED!", this.rows[rowIndex][cell]);
  }
  back() {
    this.location.back();
  }

  async printPDF(urlPdf) {
    let response = await fetch(urlPdf);
    let data = await response.blob();
    var blob = new Blob([data], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = blobUrl;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }
}

//========================================================================================================

@Component({
  selector: "view-progress-dialog",
  template: require('./view-progress-dialog.component.html'),
  providers: [HttpService, SessionHandler],
})
export class ViewProgressDialog {
  urlSafe: SafeResourceUrl;
  urlList: any = [];
  safeUrlList: any = [];
  constructor(
    public dialog: MdDialog,
    private commonService: CommonService,
    public sanitizer: DomSanitizer
  ) {}
  ngOnInit(): void {
    //this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  public fullView(docUrl) {
    window.open(docUrl, "_blank");
  }

  public closeDialog() {
    this.dialog.closeAll();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/progress-status/progress.component.ts